'use client';
import { isString, isFunction } from '@s7/utils';
import { isColorScalar } from '../../../modules/colors/impl/validators/validators.js';

const tryTransform = (transformer, candidate, name)=>{
    if (isFunction(transformer)) {
        return transformer(candidate);
    }
    const transform = transformer[name];
    if (transform && isFunction(transform)) {
        return transform(candidate);
    }
};
const themeColor = (theme)=>(raw, fallback, transforms)=>{
        if (raw === undefined || raw === null) {
            return fallback ? fallback : 'none';
        }
        const [name, shade] = raw.split('.');
        if (name in theme.palette) {
            const semanticColor = shade ? theme.palette[name][shade] : theme.palette[name];
            if (semanticColor) {
                if (isString(semanticColor)) {
                    return semanticColor;
                }
                if (transforms == null ? void 0 : transforms.palette) {
                    const result = tryTransform(transforms == null ? void 0 : transforms.palette, semanticColor, name);
                    if (result) {
                        return result;
                    }
                }
                return semanticColor;
            }
        }
        if (name in theme.invariants) {
            const invariant = shade ? theme.invariants[name][shade] : theme.invariants[name];
            if (invariant) {
                if (isString(invariant)) {
                    return invariant;
                }
                if (transforms == null ? void 0 : transforms.invariants) {
                    const result = tryTransform(transforms == null ? void 0 : transforms.invariants, invariant, name);
                    if (result) {
                        return result;
                    }
                }
                return invariant;
            }
        }
        if (name in theme.colors) {
            const color = shade ? theme.colors[name][shade] : theme.colors[name];
            if (color) {
                if (isString(color)) {
                    return color;
                }
                if (transforms == null ? void 0 : transforms.colors) {
                    const result = tryTransform(transforms == null ? void 0 : transforms.colors, color, name);
                    if (result) {
                        return result;
                    }
                }
                return color;
            }
        }
        if (isColorScalar(raw)) {
            return raw;
        }
        return fallback || 'none';
    };

export { themeColor };
//# sourceMappingURL=themeColor.js.map
